import { toast as sonnerToast } from "sonner";

export const toast = {
  error: (message: string, options?: { readonly id?: string }) =>
    sonnerToast.error(message, options),
  info: (message: string) => sonnerToast.info(message),
  success: (message: string) => sonnerToast.success(message),
  warning: (message: string) => sonnerToast.warning(message),
} as const;
